import fetchService from '@xanadu/ui-shared/utils/fetchService';
import { camelizeKeys } from 'humps';

const OPTIONS = {
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Id-Type': 'String'
  }
};

function constructSearchUrl(query, language, product) {
  return `/beta/api/search?language=${language}&products=${product}&limit=20&offset=0&query=${query}`;
}

// eslint-disable-next-line import/prefer-default-export
export function fetchSearch({ query, language, product }) {
  return fetchService(
    constructSearchUrl(query, language, product), OPTIONS, { camelizeKeys: false }
  )
    .then(json => json.results.reduce((acc, item) => {
      const type = item.type.toLowerCase();

      if (type === 'casino') {
        return acc;
      }

      const sport = item.categories.reduce((prev, category) => {
        if (prev) return prev;

        if (category.type.toLowerCase() === 'sport') {
          return category['url-name'];
        }
        return false;
      }, false);

      const camelizedItem = camelizeKeys({ ...item });

      acc.push({
        sport,
        id: camelizedItem.id,
        name: camelizedItem.name,
        metaTags: camelizedItem.categories,
        startTime: camelizedItem.startTime,
        score: camelizedItem.score,
        type
      });

      return acc;
    }, []))
    .catch((err) => { throw err; });
}
